<template>
  <div class="my-3">
    <b-row align-v="center">
      <b-col :sm="labelWidth" class="text-left">
        <label :class="validationStyle" class="mb-0 align-middle">{{this.label}}  <span v-if="required&&label" :class="validationState?'form-valid':'form-invalid'" style="font-size: 1rem;">*</span></label>
      </b-col>
      <b-col :sm="inputWidth">
        <date-picker class="FITDatePicker FITInput " v-bind:class="[{ disabled: disabled },DatePickerStyle]" :lang='lang' :placeholder="this.placeholder" :disabled="this.disabled" :format="this.format" :value="value"  @change="change($event)"></date-picker>
      </b-col>
    </b-row>
    <b-row align-v="center" align-h="end">
      <b-col :sm="inputWidth">
        <span class="form-invalid" v-if="validationState==false">{{errorMsg}}<br/></span>
<!--               <span> {{validatorObject}} </br> {{validationState}} </br> {{this.fieldInput}}</span>   
 -->        <span style="display: none;">{{getRuleByField}}{{validatorObject}}</span>
      </b-col>
    </b-row>
  </div>
</template>
<script type="text/javascript">
/* eslint-disable */
import Vue from 'vue'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import { required } from 'vuelidate/lib/validators'
import FITValidationBus from './FITValidationBus';


export default {
  name: 'FITDatePicker',
  components: {
    DatePicker
  },
  props: {
    label: String,
    placeholder: String,
    disabled: Boolean,
    value: String,
    width: {
      type: Number,
      default: 10
    },
    // lang: String,
    format: { // Format list refer to : https://mengxiong10.github.io/vue2-datepicker/
      type: String,
      default: 'YYYY-MM-DD'
    },

    rule: { type: Object, default: function() { return {} } },
    field: String,
    vuexObject: { type: String, default: "default" },
    vuexModule: { type: String, default: "Validation" },
    vuexMutation: { type: String, default: "setValidationResult" },
  },
  data() {
    return {
      // value:this.initValue, // Input String Value
      lang: {
        days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      },
      inputWidth: this.width,
      fieldInput: this.value,
      vuexValidator: false,

    }
  },
  created(){

  },
  validations() {
    if (this.required == true) {
      return {
        fieldInput: { required },
      }
    } else {
      return {
        fieldInput: {}
      }
    }
  },
  watch: {
    fieldInput: {
      deep: true,
      immediate:true,
      handler(val) {
        // console.log(val);
        this.$emit('validation', this.validationState);
        if ((val)&&(val!="0000-00-00 00:00:00")) {
          this.$emit('input', this.dateFormatter(val));
        } else {
          this.$emit('input', null);
        }
      }
    },

    value:{
      handler(val){
          this.change(val);
      },
      immediate: true
    }
  },
  mounted() {
    // console.log(this.label);
    // console.log(this.fieldInput);
    this.labelCheck(this.label);
        // onListen Reset 
    FITValidationBus.$on('reset', (value) => {
      if(value){
        // console.log("onEmit");
      if(this.$v){
        this.$nextTick(() => { this.$v.$reset() }) 
      }
      }
    });
    // onListen dirty 
    FITValidationBus.$on('dirty', (value) => {
      if(value){
        if(value == this.vuexObject){
        // console.log("onDirty");
        this.$nextTick(() => { this.$v.fieldInput.$touch() });
          this.$emit('validation', this.validationState);
        }
      }
    });
    if (this.fieldInput) {
      this.$v.fieldInput.$touch();
    }
    // Initial Dirty
    this.$nextTick(() => { this.$v.$reset() }) 
  },

  computed: {
    getRuleByField() {
      let rules = this.$store.getters[`${this.vuexModule}/getRuleByField`];
      let result = rules(this.field);
      if (Object.keys(result).length > 0) {
        this.vuexValidator = true;
        // console.log(result);
      }else{
        this.vuexValidator = false;
      }
      return result;
    },
    required() {
      if (this.vuexValidator) {
        return true;
      }

      if (this.rule.required == true) {
        return true;
      } else {
        return false;
      }
    },
    getValidationFinalCheck() {
      if (!this.vuexModule) {
        return false;
      }
      return this.$store.getters[`${this.vuexModule}/getValidationFinalCheck`];
    },
    errorMsg() {
      return this.$t('validation.errorMsg.required');
    },
    validatorObject() {
      return this.$v.fieldInput;
    },
    validationState() {
      if ((!this.required) || (this.disabled)) {
        return null;
      }
      if (this.getValidationFinalCheck) {
        this.$v.fieldInput.$touch();
      }
      // Valdiation State Check
      let dirty = this.$v.fieldInput.$dirty;
      let invalid = this.$v.fieldInput.$invalid;
      let state = null;
      if (!dirty) {
        state = null;
      } else {
        if (invalid) {
          state = false;
        } else {
          if (!this.fieldInput) {
            state = null;
          } else {
            state = true;
          }
          if(this.fieldInput == "0000-00-00 00:00:00"){
            state = false;
          }


        }
      }
      // Update to Vuex
      if (this.field) {
        this.$store.commit(`${this.vuexModule}/${this.vuexMutation}`, {
          object: this.vuexObject,
          field: this.field,
          result: state,
        });
      }
      return state;
    },
    validationStyle() {
      if (this.validationState == null) { return; }
      if (this.validationState == true) { return 'form-valid'; }
      if (this.validationState == false) { return 'form-invalid'; }
    },
    DatePickerStyle() {
      if (this.validationState == null) { return; }
      if (this.validationState == true) { return 'datePickerFormValid'; }
      if (this.validationState == false) { return 'datePickerFormInValid'; }
    },
    labelWidth() {
      return 12 - this.inputWidth;
    }
  },
  methods: {
    labelCheck(label) {
      if (!label) {
        this.inputWidth = 12;
      }
    },
    dateFormatter(date) { // Default: YYYY-MM-DD
      if (this.format == "") { this.format = "YYYY-MM-DD"; }
      return moment(date).format(this.format);
    },
    change(event) {
      // console.log(this.label);
      

      if(!event){
       this.$v.fieldInput.$model = null;
       return;
      }

      
      // special case
      if(event == '0000-00-00 00:00:00'){
        this.$v.fieldInput.$model = null;
      }     
      
      let timeStamp = moment(event).format('x');
      if(timeStamp < 1){
        event = '1970-01-02 00:00:00';
      }else if(timeStamp > 32503564800000){
        event = '2999-12-31 00:00:00';
      }

      // normal case
      this.$v.fieldInput.$model = this.dateFormatter(event);




    }
  }
}

</script>
<style>
.FITDatePicker {
  width: 100% !important;
}

.FITDatePicker input.mx-input {
  border: 1px solid #CDCDCD;
  box-shadow: none;
}

.datePickerFormValid input.mx-input {
  border: 1px solid #4dbd74 !important;
}

.datePickerFormInValid input.mx-input {
  border: 1px solid #f86c6b !important;
}

</style>



// WEBPACK FOOTER //
// src/components/Form/FITDatePicker.vue